export enum EstimatedTime {
    MIN_10 = '10',
    MIN_15 = '15',
    MIN_20 = '20',
    MIN_25 = '25',
    MIN_30 = '30',
    MIN_40 = '40',
    MIN_50 = '50',
    MIN_60 = '60',
    MIN_90 = '90'
}